import { NameDto } from '../../Common/Types'

export interface ClientScreeningCasesDto {
  id: string
  caseId: string | null
  systemCaseId: string | null
  status: NameDto
  ongoingScreeningEnabled: boolean
  latestRequiredReviewDate: string | null
  createdAt: string
  client: {
    id: string
    clientAreaId: string | null
    userName: string | null
    name: string | null
    tickmillCompanyId: number
    countryId: string | null
    teams: TeamBasicDto[]
  }
}

interface TeamBasicDto {
  id: string
  name: string | null
  tickmillCompany: TickmillCompanyDto
}

interface TickmillCompanyDto {
  id: number
  name: string | null
  shortName: string | null
}

export enum ClientScreeningCasesKey {
  caseId = 'caseId',
  systemCaseId = 'systemCaseId',
  statusId = 'status.id',
  ongoingScreening = 'ongoingScreeningEnabled',
  latestReview = 'latestRequiredReviewDate',
  createdDate = 'createdAt',
  clientName = 'client.name',
  tickmillCompany = 'client.tickmillCompany.name',
}

export enum ClientScreeningCasesFilterKey {
  client = 'ClientId',
  status = 'ScreeningStatusId',
  tickmillCompany = 'TickmillCompany',
}
